import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { Const, ResourceType } from '../../../../core/helpers/Const';
import { NotificationsService } from '../../../../service/services/misc/notifications/notifications.service';
import { Observable } from 'rxjs';
import { SwaService } from '../../../../service/services/misc/swa/swa.service';

@Component({
    selector: 'app-delete-confirmation-dialog',
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrls: ['./delete-confirmation-dialog.component.scss'],
    standalone: false
})
export class DeleteConfirmationDialogComponent implements OnInit {
    resource: ResourceModel;
    type: string;
    msg: string;
    title: string;
    errorMsg: string;
    Const = Const;
    deleteFunc: () => Observable<any>;
    loading = false;

    constructor(
		public dialogRef: DialogRef,
		private notificationsService: NotificationsService,
		private swaService: SwaService
    ) {}

    FAILED_MSGS: { [key: string]: string } = {
        [ResourceType.FOLDER]: 'Cannot delete folder',
        [ResourceType.ORGANIZATION]: 'Cannot delete organization',
        [ResourceType.RESOURCE_GROUP]: 'Cannot delete resource group',
    };

    DELETING_MSGS: { [key: string]: string } = {
        [ResourceType.FOLDER]: 'Deleting folder...',
        [ResourceType.ORGANIZATION]: 'Deleting organization...',
        [ResourceType.RESOURCE_GROUP]: 'Deleting resource group...',
    };
    ngOnInit(): void {
        let data = this.dialogRef.data;
        this.type = 'warning';
        this.title = data.title;
        this.resource = data.resource;
        this.deleteFunc = data.deleteFunc;
        this.msg = `Are you sure you want to delete '${this.resource.displayName}' (${this.resource.name})?`;
    }

    onDelete() {
        this.swaService.sendCustomEvent(
            this.swaService.SWA_EVENT_TYPES.CONFIRM_DELETE_RESOURCE,
            [this.resource.type, this.resource.name],
            []
        );
        this.loading = true;
        this.dialogRef.loading(true);

        this.deleteFunc()
            .subscribe({
                next: this.onSuccess.bind(this),
                error: (err: Error) => {
                    this.errorMsg = err.message;
                },
            })
            .add(() => {
                this.loading = false;
                this.dialogRef.loading(false);
            });
    }

    onSuccess() {
        this.notificationsService.showMessageToast(
            'Deleting resource ' + this.resource.name + ' (' + this.resource.type + ')...'
        );
        this.dialogRef.close(this.resource);
    }

    validate() {
        return !this.loading;
    }
}
